import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { UserService } from '../../shared/user.service';
import { analyzeAndValidateNgModules } from '@angular/compiler';
import swal from 'sweetalert2';
@Component({
  selector: 'app-chit-claim',
  templateUrl: './chit-claim.component.html',
  styleUrls: ['./chit-claim.component.css'],
  providers: [DatePipe]
})
export class ChitClaimComponent implements OnInit {
   title="Chit Claim";
  data: any = {};
  c: any = {};
  ChitClaimList: any;
  ChitSchemeList:any;
  SurityList:any;
  CategoryList:any;
  AccountList:any;
  MonthList:any;
  BidDetailsList:any;
  CollectedAmountList:any;
  myDate:any;
  month:any;
  MonthName:any;
  Coll_Amount:any;
  CustomerList:any;
  ACC_NO:any;
  Chit_Amount:number;
  NOOFMEM:number;
  GlSub:any;
  a:any={}
  CustomerBlcList:any;
  logdbranch:any;
  constructor(private service: UserService,private datePipe: DatePipe) 
  { 

  }
  ngOnInit() 
  {

     this.myDate =new Date();
     this.c.myDate = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
     this.c.GetDate = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
     this.c.GetDat = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
     this.GetChitClaimList(); 
     this.GetChitScheme();
     this.GetSurityDetails();
     this.logdbranch=localStorage.getItem('BRANCH_ID');
  }

  GetChitClaimList() 
  {
    debugger;
    this.data = this.service.ChitClaim();
    this.data.subscribe(
      (response) => {
        this.ChitClaimList = response;
       this.c.ChitClaimNo= this.ChitClaimList.CLAIM_NO;
        console.log(response);
        console.log(this.ChitClaimList);
      })
  }

  GetChitScheme()
  {
    this.data = this.service.GetChitScheme();
    this.data.subscribe(
      (response) => {
        this.ChitSchemeList = response.SchmeClaimModel;
        console.log(response);
        console.log(this.ChitSchemeList);
      })
  }

  GetSurityDetails()
  {
    debugger;
    this.data = this.service.GetSurity();
    this.data.subscribe(
      (response) => {
        this.SurityList = response.SurityModel;
        console.log(response);
        console.log(this.SurityList);
      })
  }

  GetCategory(ID) {
    debugger;
    console.log(ID);
    this.data = this.service.CategoryDetails(ID);
    this.data.subscribe(
      (Response: any) => {
        this.CategoryList = Response.Result;
        console.log('BranchList')
        this.c.Surity_Id=ID;
        console.log(this.CategoryList);
      });
  }

  GetName(ID:any)
  {
     for(var i=0;i<this.AccountList.length;i++)
     {
      if(this.AccountList[i].acc_no ==ID)
      {
         this.c.Customer_Name=this.AccountList[i].name;
         this.c.Customer_Acc=ID;

      }
      if(this.AccountList[i].acc_no ==ID)
      {
         this.c.Customer_Acc_Id=this.AccountList[i].Acc_Id;     
      }
     
   }
  }
  GetNumber(Acc_Id:any,GlSub_Id:any)
  {
     this.data = this.service.GetCustomerBLC(Acc_Id,GlSub_Id);
     this.data.subscribe(
       (Response: any) => {
         this.CustomerBlcList = Response.Result;
         console.log('CustomerBlcList')
         console.log(this.CustomerBlcList);
       })
  }
  GetAccountNo(ID,modid) {
    debugger;
    console.log(ID);
    this.data = this.service.AccountDetails(ID,modid,this.logdbranch);
    this.data.subscribe(
      (Response: any) => {
        this.AccountList = Response.Result;
        console.log('AccountList')
        console.log(this.AccountList);
        this.c.GlSub_ID_Acc=ID;
      });
  }
  GetCHITSCHEME_NO(CHITSCHEME_NO) {
    
    console.log(CHITSCHEME_NO);
    this.data = this.service.MonthDetails(CHITSCHEME_NO);
    this.data.subscribe(
      (Response: any) => {
        this.MonthList = Response.Result;
        console.log('MonthList')
        console.log(this.MonthList);
     for(var i=0;i<this.MonthList.length;i++)
     {
      debugger;
      if(this.MonthList[i].Month_NO > 0)
      {
         this.month=this.MonthList[i].Month_NO;
         this.MONTHNAME(this.month)
         this.c.Month_Name=this.MonthName;
         // this.GetGlSub(CHITSCHEME_NO);
         
      }
    
    }
      });
  }
  MONTHNAME(month:any)
  {
    
      debugger;
      if(month==1)
      {
         this.myDate =new Date();
         this.c.myDate = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
         let monthName:string=this.c.myDate;
         monthName=monthName.substring(0,4);
         this.c.MonthName='JANUARY' +',' + monthName;
      }

      if(month==2)
      {
         this.myDate =new Date();
         this.c.myDate = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
         let monthName:string=this.c.myDate;
         monthName=monthName.substring(0,4);
         this.c.MonthName='FEBRUARY' +',' + monthName;
      }

      if(month==3)
      {
         this.myDate =new Date();
         this.c.myDate = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
         let monthName:string=this.c.myDate;
         monthName=monthName.substring(0,4);
         this.c.MonthName='MARCH' +',' + monthName;
      }

      if(month==4)
      {
         this.myDate =new Date();
         this.c.myDate = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
         let monthName:string=this.c.myDate;
         monthName=monthName.substring(0,4);
         this.c.MonthName='APRIL' +',' + monthName;
      }

      if(month==5)
      {
         this.myDate =new Date();
         this.c.myDate = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
         let monthName:string=this.c.myDate;
         monthName=monthName.substring(0,4);
         this.c.MonthName='MAY' +',' + monthName;
      }
      if(month==6)
      {
         this.myDate =new Date();
         this.c.myDate = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
         let monthName:string=this.c.myDate;
         monthName=monthName.substring(0,4);
         this.c.MonthName='JUNE' +',' + monthName;
      }
      if(month==7)
      {
         this.myDate =new Date();
         this.c.myDate = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
         let monthName:string=this.c.myDate;
         monthName=monthName.substring(0,4);
         this.c.MonthName='JULY' +',' + monthName;
      }
      if(month==8)
      {
         this.myDate =new Date();
         this.c.myDate = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
         let monthName:string=this.c.myDate;
         monthName=monthName.substring(0,4);
         this.c.MonthName='AUGUST' +',' + monthName;
      }

      if(month==9)
      {
         this.myDate =new Date();
         this.c.myDate = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
         let monthName:string=this.c.myDate;
         monthName=monthName.substring(0,4);
         this.c.MonthName='SEPTEMBER' +',' + monthName;
      }

      if(month==10)
      {
         this.myDate =new Date();
         this.c.myDate = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
         let monthName:string=this.c.myDate;
         monthName=monthName.substring(0,4);
         this.c.MonthName='OCTOBER' +',' + monthName;
      }
      if(month==11)
      {
         this.myDate =new Date();
         this.c.myDate = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
         let monthName:string=this.c.myDate;
         monthName=monthName.substring(0,4);
         this.c.MonthName='NOVEMBER' +',' + monthName;
      }
      if(month==12)
      {
         this.myDate =new Date();
         this.c.myDate = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
         let monthName:string=this.c.myDate;
         monthName=monthName.substring(0,4);
         this.c.MonthName='DECEMBER' +',' + monthName;
      }
      // else
      // {
      //    this.myDate =new Date();
      //    this.c.myDate = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
      //    let monthName:string=this.c.myDate;
      //    monthName=monthName.substring(0,4);
      //    this.c.MonthName='JANUARY' +',' + monthName;
      // }
      
  }
  GetCollectedAmount(CHITSCHEME_NO:any)
  {
    debugger;
    this.data = this.service.CollectedAmountDetails(CHITSCHEME_NO);
    this.data.subscribe(
      (Response: any) => {
        this.CollectedAmountList = Response.Result;
        console.log('CollectedAmountList')
        console.log(this.CollectedAmountList);

     for(var i=0;i<this.CollectedAmountList.length;i++)
     {
      debugger;
      if(this.CollectedAmountList[i].CoolectedAmount > 0)
      {
         this.Coll_Amount=this.CollectedAmountList[i].CoolectedAmount;
          this.c.CollectedAmount=this.Coll_Amount
      }}
   });
  }
  GetCustomerDetails(Ticket_No:number,GlSub:any)
  {
     debugger
     console.log(Ticket_No);
     this.data = this.service.CustomerDetails(Ticket_No,GlSub);
     this.data.subscribe(
       (Response: any) => {
         this.CustomerList = Response.Result;
         console.log('CustomerList')
         console.log(this.CustomerList);

     for(var i=0;i<this.CustomerList.length;i++)
     {
      debugger;
      if(this.CustomerList[i].ACC_NO)
      {
         this.ACC_NO=this.CustomerList[i].ACC_NO;
          this.c.ACC_NO=this.ACC_NO
      }

      if(this.CustomerList[i].NAME1)
      {
         this.c.NAME1=this.CustomerList[i].NAME1;
      }

      if(this.CustomerList[i].MCODE)
      {
         this.c.MCODE=this.CustomerList[i].MCODE;
      }
   }  
   });
  }

  GetDetails(CHITSCHEME_NO:any,Bid_Amount:any)
  {
      debugger;

    this.data = this.service.BidDetails(CHITSCHEME_NO);
    this.data.subscribe(
      (Response: any) => {
        this.BidDetailsList = Response.Result;
        console.log('BidDetailsList')
        console.log(this.BidDetailsList);

        for(var i=0;i<this.BidDetailsList.length;i++)
        {
         debugger;
         if(this.BidDetailsList[i].Comm_Amount)
         {
            this.c.Comm_Amount=this.BidDetailsList[i].Comm_Amount;
         }
         if(this.BidDetailsList[i].NOOFMEM)
         {
            this.NOOFMEM=this.BidDetailsList[i].NOOFMEM;
         }
         if(this.BidDetailsList[i].ChitAmount)
         {
            this.Chit_Amount=this.BidDetailsList[i].ChitAmount;
            this.c.Claim_Amount= this.Chit_Amount - Bid_Amount ;
            let Blance:number=this.Chit_Amount - this.c.Comm_Amount - this.c.Claim_Amount ;
            this.c.Devdent_Amount=Blance;
         }
      } 
      });

  }

  GetGlSub(CHITSCHEME_NO:any)
  {
   debugger;
   for(var i=0;i<this.ChitSchemeList.length;i++)
   {
    debugger;
    if(this.ChitSchemeList[i].CHITSCHEME_NO==CHITSCHEME_NO)
    {
       this.c.GlSub=this.ChitSchemeList[i].glsub_id;
    }
    
 } 
}

PostData(c)
{
   debugger;
   document.getElementById('loader-spinner').style.display = "block";
   //this.a.Bid_Amount=c.Bid_Amount;
   this.data = this.service.SaveClaim(c);
   this.data.subscribe(
     (response: any) => 
     {
      this.Cancel();
      document.getElementById('loader-spinner').style.display = "none";
      swal('Success!', 'Transactions Added Successfully .', 'success');
     },
     (error) => {
       //document.getElementById('loader-spinner').style.display = "none";
     }

   );
   
}
//   Swal('Success!', 'Transactions Added Successfully .', 'success');

Cancel()
{
   debugger;
   this.c.ChitClaimNo='';
   this.c.Month_Name='';
   this.c.CHITSCHEME_NO='';
   this.c.Ticket_N='';
   this.c.MCODE='';
   this.c.ACC_NO='';
   this.c.NAME1='';
   this.c.CollectedAmount='';
   this.c.Comm_Amount='';
   this.c.Bid_Amount='';
   this.c.Claim_Amount='';
   this.c.Devdent_Amount='';
   this.c.Remarks='';
   this.c.DOC_CODE='';
   this.c.glsub_id='';
   this.c.acc_no='';
   this.c.MonthName='';
   this.c.GetDat='';
   this.c.Surity_Id='';

   this.c.GlSub_ID_Acc='';
   this.c.Customer_Acc='';
   this.c.Customer_Name='';
   this.c.GetDat='';













}
}



// WEBPACK FOOTER //
// ./src/app/chitfund/chit-claim/chit-claim.component.ts